import React from "react";
import img1 from "../pages/Image/gorilla1.jpg";
import img2 from "../pages/Image/gorilla2.jpg";
import img3 from "../pages/Image/gorilla3.jpg";
import './destination.css';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';  
import SimpleImageSlider from "react-simple-image-slider";
import Swipernew from "./Swipernew";
import slide_image_1 from '../pages/image1/IMG-20240928-WA0023.jpg';
import slide_image_2 from '../pages/image1/IMG-20240928-WA0022.jpg';
import slide_image_3 from '../pages/image1/IMG-20240928-WA0014.jpg';
import slide_image_4 from '../pages/image1/IMG-20240928-WA0018.jpg';

export default function Destination3() {

 const imageArray = [
  slide_image_1,
  slide_image_2,
  slide_image_3,
  slide_image_4,
 
];
  return (
    <>
  <div>
  <div>
            <Swipernew images={imageArray} />
        </div>
  <div className=" m-2 pt-5 ">
        <div className="container-fluid">
        <div className="ms-auto me-auto  bg2">

          <h1 className="text-center name11  ">
          3-Days Murchison Falls National Park Tour including Big 5 sighting
          </h1>
        </div>
          

          <h2>Description:</h2>
          <h3 className="ms-5 pt-3">
            <div>
              &emsp; &emsp;Murchison Falls is the largest and oldest National
              Park in Uganda. Nile River flows through the park, rushing through
              a 7-meter narrow gorge, creating the famous Murchison Falls. You
              will be amazed by the beauty, the sounds of water and its
              surroundings. Nothing will match your excitement seeing herds of
              giraffes, elephants, lions the king of the jungle, and antelopes
              walking around in their natural habitat.
            </div>
            <div>
              &emsp; &emsp; You have an opportunity to go on a launch trip on
              Victoria Nile, where you will look out for the Nile crocodiles
              basking in the sun and pods of hippos. Murchison Falls is home to
              over 451 bird species such as the Great blue Turaco, Goliath
              heron, the Shoe-bill, and the dwarf kingfisher among others,76
              mammal. The activities also include Visit to the Ziwa Rhino
              Sanctuary, game drive and Boat cruise along the River Nile.
            </div>
          </h3>
        </div>
        <div className="container-fluid p-5">
          <Box sx={{ padding: 2 }}>
            <Stepper orientation="vertical" activeStep={3}>
              {steps.map((step, index) => (
                <Step key={step.label1} color="black">
                  <StepLabel><h3>{step.label1}</h3></StepLabel>
                  <div className="bordernew">
                    <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
                      <h4><b>{step.label}</b></h4>
                    </Typography>
                    <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography>
                  </div>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
        

        
      </div>
      <div class="btn-box text-white text-center">
                        <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
                    </div>
  </div>

     
    </>
  );
}
const steps = [
  {
    label1: 'Day - 1',
    label: 'Transfer to Murchison Falls via Ziwa Rhino Sanctuary',
    description: ` 
After Rhino tracking you will have another stop in Masindi where
                you will indulge and experience our local cuisine for lunch,
                after lunch proceed to the park, after making payments for park
                entry drive towards the top of the falls, here along the way you
                will see various animals such as warthogs, baboons among others
                 After Rhino tracking you will have another stop in Masindi where
                you will indulge and experience our local cuisine for lunch,
                after lunch proceed to the park, after making payments for park
                entry drive towards the top of the falls, here along the way you
                will see various animals such as warthogs, baboons among others.`,
  },
  {
    label1: 'Day - 2',
    label: 'Morning Game Drive and Boat Cruise',
    description: ` Wake up early morning and have breakfast at around 06:30. Your
                driver and the ranger guide will pick you up from the lodge to
                start your Game drive at 07:00. Expect to see very many animals
                such as lions, buffaloes, giraffes, elephants, antelopes, water
                bucks and birds among others during the drive. 


                The game drive will take approximately 5 and a half hours and
                after that you will be driven back to the lodge, relax/freshen
                up and have lunch as you prepare for the afternoon boat cruise.

                 You will be able to see various Nile crocodiles, hippos,
                buffaloes, elephants along the banks of the Nile as well as
                different beautiful birds, some singing in the trees such as the
                bee eaters, the colored kingfishers, the shoe billed stork and
                many others. The boat ride will take you to the base/bottom of
                the Murchison Falls where you will have a beautiful view and
                feelings of the Falls. Return to your accommodation thereafter.`,
  },
  {
    label1: 'Day - 3',
    label: 'the morning on your way back to Kampala',
    description: `Enjoy your breakfast; thereafter proceed for another Game drive
                in the morning on your way back to Kampala. It will be a great
                time as you look out for various animal species as they continue
                with their daily lives in the Savanna grasslands as they look
                out for food most especially buffaloes, elephants, giraffes,
                lions, antelopes, not forgetting a number of bird species. \n\n

                You will leave the park and on enroute have a stopover in
                Masindi for lunch and continue with the journey as you enjoy the
                beautiful sceneries of the Uganda’s landscape reaching
                Kampala/Entebbe in the evening. Meal Plan: Breakfast and Lunch. \n\n

                 Entebbe airport drop off is included. End of safari `,
  }
];
